/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UserTenantResponseList {
    getFixupPrototypeFunction() { return UserTenantResponseList.fixupPrototype; }

    static newInstance(model: Partial<UserTenantResponseList>): UserTenantResponseList {
        let obj = Object.assign(new UserTenantResponseList(), model);
        UserTenantResponseList.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UserTenantResponseList>): UserTenantResponseList {
        if (!model) return null;
        return UserTenantResponseList.newInstance(<UserTenantResponseList> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UserTenantResponseList) {
        if (!obj) return;

        models.UserTenantResponseList.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UserTenantResponseList): boolean {
        Object.setPrototypeOf(obj, UserTenantResponseList.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.total_count === undefined) {
            this.total_count = 0;
        }
        if (this.users) {
            for (let val of this.users) {
                models.UserTenantDetails.fixupPrototype(val);
            }
        }
    }

    /**
     * Number of users in CoreStack account.
     */
    total_count: number;

    /**
     * List all users within a CoreStack account.
     */
    users: Array<models.UserTenantDetails>;

}
